module.exports = __webpack_public_path__ + "static/img/logo-bg.7ef8aadf.svg";